import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './OutAndUnderPerformers.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../Activity_Track/CallTrackApi";


function OutAndUnderPerformers(props) {
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let optionInfoMarket = "Out / Under Performers";
    const [data, setData] = useState([]);
    let optionTypeComp = "Daily Market Tracker";
    const [valuebtn, setValueBtn] = useState("u");
    const [valueLi, setValueLi] = useState("50");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    // const [valueLl, setValueLl] = useState("BSE");
    // const [valueLt,setValueLt] = useState("u");
    const [valueLy, setValueLy] = useState("1M");
    const [groupIndex, setGroupIndex] = useState("B");
    const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const [loadingshow, setloadingshow] = useState(false);

    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);

        if (groupValue === "BSE") {
            const getUrl = BaseURL + "OutUnderPerformers";

            fetch(`${getUrl}/${groupValue}/${groupIndex}/${valueLy}/${valueLi}/${valuebtn}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    // console.log(getData, "getData")
                    setloadingshow(false);

                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "OutUnderPerformers";
            fetch(`${getUrl}/${groupValue}/${groupIndexNSE}/${valueLy}/${valueLi}/${valuebtn}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //console.log(getData, "getData")
                    setloadingshow(false);

                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue, groupIndex, valueLy, valuebtn, valueLi, groupIndexNSE]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    CallTrackApi("Out Under Performers",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Out / under Performers</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='outpf-loser-sc'>
                            <div className='outpf-header'>
                                <h2><span>Out / Under Performers</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='outpf-table-main'>
                                <div className='dropdowndiv'>
                                    {/* <div className='outpf-loser-toggle'>
                                        <button id="btnGain" value="o" className={(valuebtn === "o") ? "TabActive" : 'unActive'} onClick={(event) => { setValueBtn(event.target.value) }}>Out Performers</button>
                                        <button id="btnLoose" value="u" className={(valuebtn === "u") ? "TabActive" : 'unActive'} onClick={(event) => { setValueBtn(event.target.value) }}>Under Performers</button>
                                    </div> */}
                                    <div className='outpf-loser-toggle'>
                                        <button id="btnGain" value="o" className={(valuebtn === "o") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Out Performers</button>
                                        <button id="btnLoose" value="u" className={(valuebtn === "u") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Under Performers</button>
                                    </div>
                                    <div className='outpf-right'>
                                        <div className='outpff-inner-select'>

                                            <select onChange={(event) => { setValueLy(event.target.value); }}>
                                                <option value="1M" selected>Last 1 Month</option>
                                                <option value="3M" >Last 3 Month</option>
                                                <option value="6M" >Last 6 Month</option>
                                                <option value="1Y" >Last 1 Year</option>
                                                <option value="3Y" >Last 3 Years</option>
                                            </select>
                                        </div>

                                        <div className='outpf-inner-selectI'>
                                            <select onChange={(event) => { setGroupValue(event.target.value); setGroupIndex("BSE_SENSEX"); setGroupIndexNSE("NIFTY") }}>
                                                <option value="BSE" selected>BSE</option>
                                                <option value="NSE">NSE</option>
                                            </select>
                                        </div>
                                        <div className='outpf-inner-select'>
                                            {(groupValue === "BSE") ?
                                                <select onChange={(event) => { setGroupIndex(event.target.value) }}>
                                                    {dataGroup && dataGroup.map(({ Group }) => (
                                                        <option value={Group} selected={Group === "BSE_SENSEX"}>{Group}</option>
                                                    )
                                                    )}
                                                </select> : <select onChange={(event) => { setGroupIndexNSE(event.target.value) }}>
                                                    {dataGroup && dataGroup.map(({ Group }) => (
                                                        <option value={Group} selected={Group === "NIFTY"}>{Group}</option>
                                                    )
                                                    )}
                                                </select>}
                                        </div>
                                    </div>
                             </div>

                                {/* <hr className="hrOutUnder"></hr> */}
                                <div className='outpf-table table-responsive'>
                                    <table className='table'>
                                        <thead>

                                            <tr>
                                                <th id="ContentPlaceHolder1_outunderhead" className='bdrright padbottom30' rowspan="2">Out Performers</th>
                                                <th className='text-right bdrright bdrbottom'> Prev Close On</th>


                                                <th className='text-right bdrright bdrbottom'>Prev Day Close</th>

                                                <th className='text-right bdrright bdrbottom' colSpan="2">Gain/Loss</th>
                                                <th id="ContentPlaceHolder1_outunder" className="text-right" rowspan="2">Outperformed By</th>

                                            </tr>

                                            <tr>
                                                {(data[0] != undefined) ?
                                                    <><th id="ContentPlaceHolder1_tdOPDate1" className="text-right bdrright">{data[0].closedate}</th>
                                                        <th id="ContentPlaceHolder1_tdOPDate2" className="text-right bdrright">{data[0].closedate1}</th></> : ''}

                                                <th className="text-right bdrright">Diff</th>
                                                <th className="text-right bdrright">%</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ Lname, Close1, Close, Diff, PerChg, OPVAL, CO_CODE }) => (
                                                    <tr>
                                                        <td className="text-left"><h6 onClick={routeChange} data-id={Lname + '-' + CO_CODE}>{Lname}</h6></td>
                                                        <td className="text-right"> {(Close != null) ? Close.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {(Close1 != null) ? Close1.toFixed(2) : 0}</td>
                                                        <td className={Diff.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {(Diff != null) ? Diff.toFixed(2) : 0}</td>
                                                        <td className={PerChg.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {(PerChg != null) ? PerChg.toFixed(2) : 0}</td>
                                                        <td className={OPVAL.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {(OPVAL != null) ? OPVAL.toFixed(2) : 0}</td>

                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>

                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default OutAndUnderPerformers;